import template from './form.html';
import './form.global.css';

class FormController {
  policyCheck = {
    selected: true,
  };
}

export const FormComponent = {
  template,
  controller: FormController,
  bindings: {
    credentials: '<',
    inviteToken: '<',
    submit: '&',
  },
};
